'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ForTests = undefined;
exports.createLoginUrl = createLoginUrl;
exports.logout = logout;
exports.fetchAuthCodeToken = fetchAuthCodeToken;
exports.fetchDirectGrantToken = fetchDirectGrantToken;
exports.setAuthCode = setAuthCode;
exports.getAuthToken = getAuthToken;
exports.expiresIn = expiresIn;
exports.fetchRefreshTokenUsingConfigs = fetchRefreshTokenUsingConfigs;
exports.activateThruConfigs = activateThruConfigs;
exports.activate = activate;
exports.getServiceAccountToken = getServiceAccountToken;

var _rx = require('rx');

var _bastetjs = require('bastetjs');

var _FetchPeon = require('../peons/FetchPeon');

var _Configure = require('../Configure');

var _eventBusRx = require('event-bus-rx');

var _eventBusRx2 = _interopRequireDefault(_eventBusRx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUTH_TOKEN = 'AUTH_TOKEN';

var tokenStream = _rx.Observable.never();
var activityStream = _rx.Observable.never();

function _getAccessTokenUrl() {
  var url = keycloakURL((0, _Configure.getConfigs)().keycloakUrlBase, (0, _Configure.getConfigs)().keycloakRealm, 'protocol/openid-connect/token');
  return url;
}

function _redirectUri(options) {
  if (options && options.redirectUri) {
    return options.redirectUri;
  } else {
    var redirectUri = location.href;
    if (location.hash) {
      redirectUri = redirectUri.substring(0, location.href.indexOf('#'));
      redirectUri += (redirectUri.indexOf('?') == -1 ? '?' : '&') + 'redirect_fragment=' + encodeURIComponent(location.hash.substring(1));
    }
    return redirectUri;
  }
}

function createLoginUrl(options) {
  var state = _bastetjs.utils.guid();
  var nonce = _bastetjs.utils.guid();

  var redirectUri = _redirectUri(options);
  if (options && options.prompt) {
    redirectUri += (redirectUri.indexOf('?') == -1 ? '?' : '&') + 'prompt=' + options.prompt;
  }

  (0, _Configure.setConfigs)({
    keycloakOAuthState: {
      state: state,
      nonce: nonce,
      redirectUri: redirectUri
    }
  });

  var realm = (0, _Configure.getConfigs)().keycloakRealm;
  var clientId = (0, _Configure.getConfigs)().keycloakClientId;
  var responseMode = (0, _Configure.getConfigs)().keycloakResponseMode;
  var responseType = (0, _Configure.getConfigs)().keycloakResponseType;

  var url = keycloakURL((0, _Configure.getConfigs)().keycloakUrlBase, realm, 'protocol/openid-connect/auth') + '?client_id=' + encodeURIComponent(clientId) + '&redirect_uri=' + encodeURIComponent(redirectUri) + '&state=' + encodeURIComponent(state) + '&nonce=' + encodeURIComponent(nonce) + '&response_mode=' + encodeURIComponent(responseMode) + '&response_type=' + encodeURIComponent(responseType);

  return url;
}

function _assembleUserRequest(body) {
  var keycloakClientId = (0, _Configure.getConfigs)().keycloakClientId;
  var keycloakSecret = (0, _Configure.getConfigs)().keycloakSecret;

  return {
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: body + '&client_id=' + encodeURIComponent(keycloakClientId) + '&client_secret=' + encodeURIComponent(keycloakSecret)
  };
}

function _fetchToken(url, req) {

  return _rx.Observable.just({ token: false, isLoading: true }).concat((0, _FetchPeon.doFetch)(url, req).do(function (resp) {
    (0, _Configure.setConfigs)({
      access_token: resp.access_token,
      refresh_token: resp.refresh_token
    });
  }).map(function (resp) {
    return {
      token: resp,
      isLoading: false
    };
  })).take(2).forEach(function (data) {
    _eventBusRx2.default.publish(AUTH_TOKEN, data);
  });
}

function logout(redirectUri) {
  var realm = (0, _Configure.getConfigs)().keycloakRealm;
  var logoutUri = keycloakURL((0, _Configure.getConfigs)().keycloakUrlBase, realm, 'protocol/openid-connect/logout') + (redirectUri ? '?redirectUri=' + encodeURIComponent(redirectUri) : '');
  console.log(logoutUri);
  return (0, _FetchPeon.doFetch)(logoutUri, null, false);
}

function fetchAuthCodeToken(code, redirectUri) {
  var body = 'grant_type=authorization_code' + '&code=' + code + '&redirect_uri=' + encodeURIComponent(redirectUri);

  return _fetchToken(_getAccessTokenUrl(), _assembleUserRequest(body));
}

function fetchDirectGrantToken(username, password) {
  var body = 'grant_type=password' + '&username=' + username + '&password=' + password;

  return _fetchToken(_getAccessTokenUrl(), _assembleUserRequest(body));
}

function setAuthCode(code) {
  var redirectUri = (0, _Configure.getConfigs)().keycloakRedirectUri;
  fetchAuthCodeToken(code, redirectUri);
}

function getAuthToken() {
  var startWith = (0, _Configure.getConfigs)().access_token ? { token: (0, _Configure.getConfigs)().access_token } : { token: false };

  return _rx.Observable.just(startWith).concat(_eventBusRx2.default.getTopic(AUTH_TOKEN));
}

function expiresIn(token) {
  return decodeToken(token).exp * 1000 - epochTime();
}

function hasExpired(token) {
  return expiresIn(token) <= 0;
}

function decodeToken(tok) {
  // ref:  http://stackoverflow.com/questions/14695988/dom-exception-5-invalid-character-error-on-valid-base64-image-string-in-javascri
  var token = JSON.parse(atob(tok.split('.')[1].replace(/\s/g, '')));
  check(token, ['exp'], 'decodeToken');
  return token;
}

function epochTime() {
  return new Date().getTime();
}

function keycloakURL(urlBase, realm, suffixPath) {
  return urlBase + '/auth/realms/' + realm + '/' + suffixPath;
}

function fetchRefreshToken(urlBase, realm) {
  var params = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

  try {
    if (params.client_secret) {
      params.grant_type = 'refresh_token';
      params.refresh_token = (0, _Configure.getConfigs)().refresh_token;
      return (0, _FetchPeon.doFetch)(keycloakURL(urlBase, realm, 'protocol/openid-connect/token'), toPostRequest(params));
    } else {
      var hostUrl = (0, _Configure.getConfigs)().hostUrl;
      return (0, _FetchPeon.doFetch)(hostUrl + '/auth/token/refresh/' + realm + '/' + params.client_id, {
        method: 'post',
        headers: {
          'Content-Type': 'text/plain'
        },
        body: (0, _Configure.getConfigs)().refresh_token
      });
    }
  } catch (err) {
    console.log(err);
    return _rx.Observable.empty();
  }
}

function tap(obs) {
  obs.do(function (resp) {
    console.log(JSON.stringify(resp));
  });
}

function check(obj, params, context) {
  var missing = _.reduce(params, function (acc, key) {
    if (!obj.hasOwnProperty(key)) {
      acc.push(key);
    }
    return acc;
  }, []);

  if (missing.length) {
    throw new Error(missing.join(', ') + ' is/are missing in ' + context);
  }
}

function toPostRequest(params) {
  if (params.refresh_token) {
    check(params, ['client_id', 'client_secret'], 'toPostRequest');
    return {
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: toQueryString(params)
    };
  } else {
    throw new Error('refresh_token is not set, unable to generate a toPostRequest');
  }
}

function toQueryString(obj) {
  return _.map(obj, function (v, k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(v);
  }).join('&');
};

function refreshTokenScheduler(refreshInterval, scheduler) {
  return _rx.Observable.interval(refreshInterval, scheduler).timeInterval();
}

function activity(timestampHolder, requireActivity) {
  return requireActivity ? timestampHolder && timestampHolder.timestamp : epochTime();
}

function startTokenRefreshScheduler(scheduler) {

  check((0, _Configure.getConfigs)(), ['tokenRefreshInterval', 'keycloakUrlBase', 'keycloakRealm', 'keycloakClientId', 'requireActivity'], 'startTokenRefreshScheduler');

  var tokenRefreshInterval = (0, _Configure.getConfigs)().tokenRefreshInterval;
  var requireActivity = (0, _Configure.getConfigs)().requireActivity;

  return _rx.Observable.combineLatest(activityStream, refreshTokenScheduler(tokenRefreshInterval, scheduler))
  //     .do((msg) => { console.log(showTick(scheduler) + ' msg: ', msg); })
  .map(function (combined) {
    return activity(combined[0], requireActivity);
  })
  //     .do((lastKnownActivity) => { console.log('lkg: ' + lastKnownActivity + ' remaining: ' + (epochTime()-lastKnownActivity) + '  interval: ' + tokenRefreshInterval); })
  .filter(function (lastKnownActivity) {
    return lastKnownActivity && epochTime() - lastKnownActivity <= tokenRefreshInterval;
  })
  //     .do(() => { console.log('worthy of a refresh!' ); } )
  .flatMap(function (params) {
    return fetchRefreshTokenUsingConfigs((0, _Configure.getConfigs)());
  })
  //.do((refreshedToken) => { console.log(showTick(scheduler) + 'refreshedToken: ', refreshedToken ); } )
  ;
}

function fetchRefreshTokenUsingConfigs(configs) {
  var keycloakUrlBase = configs.keycloakUrlBase;
  var keycloakRealm = configs.keycloakRealm;
  var keycloakClientId = configs.keycloakClientId;
  var keycloakSecret = configs.keycloakSecret;

  return fetchRefreshToken(keycloakUrlBase, keycloakRealm, {
    'client_id': keycloakClientId,
    'client_secret': keycloakSecret
  });
}

function showTick(scheduler) {
  return scheduler ? 'tick(' + scheduler.clock + ') ' : '';
}

function activateThruConfigs(scheduler) {
  var access_token = (0, _Configure.getConfigs)().access_token;
  var refresh_token = (0, _Configure.getConfigs)().refresh_token;
  return activate({ access_token: access_token, refresh_token: refresh_token }, scheduler);
}

function activate(_ref, scheduler) {
  var access_token = _ref.access_token;
  var refresh_token = _ref.refresh_token;


  tokenStream = new _rx.ReplaySubject(1, null, scheduler);
  tokenStream.subscribe(function (token) {
    (0, _Configure.setConfigs)({
      access_token: token.access_token,
      refresh_token: token.refresh_token
    });
  }, function (err) {
    console.log('Error in token stream: ', err);
  }, function () {
    done();
  });

  activityStream = new _rx.ReplaySubject(1, null, scheduler);
  activityStream.onNext({ msg: 'messaging activated' });

  startTokenRefreshScheduler(scheduler).subscribe(function (msg) {
    var newToken = Array.isArray(msg) ? msg[0] : msg;
    // console.log('updating tokenStream with: ', newToken);
    tokenStream.onNext(newToken);
  });

  return { activityStream: activityStream, tokenStream: tokenStream };
}

function getServiceAccountToken() {

  var keycloakClientId = (0, _Configure.getConfigs)().keycloakClientId;
  var keycloakSecret = (0, _Configure.getConfigs)().keycloakSecret;

  if (keycloakClientId && keycloakSecret) {
    var basicAuth = btoa(keycloakClientId + ':' + keycloakSecret);
    var req = {
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Basic ' + basicAuth
      },
      body: 'grant_type=client_credentials'
    };
    return _fetchToken(_getAccessTokenUrl(), req);
  } else {
    var hostUrl = (0, _Configure.getConfigs)().hostUrl;
    var realm = (0, _Configure.getConfigs)().keycloakRealm;

    return _fetchToken(hostUrl + '/auth/token/service-account/' + realm + '/' + keycloakClientId, {
      method: 'post'
    });
  }
}

var ForTests = exports.ForTests = {
  createLoginUrl: createLoginUrl,
  fetchAuthCodeToken: fetchAuthCodeToken,
  fetchDirectGrantToken: fetchDirectGrantToken,
  getAuthToken: getAuthToken,
  setAuthCode: setAuthCode,
  fetchRefreshToken: fetchRefreshToken,
  toPostRequest: toPostRequest,
  decodeToken: decodeToken,
  epochTime: epochTime,
  expiresIn: expiresIn,
  refreshTokenScheduler: refreshTokenScheduler,
  activate: activate,
  activateThruConfigs: activateThruConfigs,
  startTokenRefreshScheduler: startTokenRefreshScheduler,
  getServiceAccountToken: getServiceAccountToken,
  fetchRefreshTokenUsingConfigs: fetchRefreshTokenUsingConfigs
};


//////////////////
// WEBPACK FOOTER
// ../~/anuket/lib/nobles/KeycloakNoble.js
// module id = 423
// module chunks = 0